import { Delete } from 'lucide-react'

import { cn } from '@/lib/utils'

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', 'back'] as const

interface NumPadProps {
  value: string
  onChange: (value: string) => void
  /** Digits allowed after the point: 2 for money, 3 for weights. */
  decimals?: number
  className?: string
}

/** On-screen keypad for touch tills. Physical keyboards type into the amount field directly. */
export const NumPad = ({ value, onChange, decimals = 2, className }: NumPadProps) => {
  const press = (key: (typeof KEYS)[number]) => {
    if (key === 'back') return onChange(value.slice(0, -1))
    if (key === '.' && value.includes('.')) return
    if (new RegExp(`\\.\\d{${decimals}}$`).test(value)) return
    onChange(value === '0' && key !== '.' ? key : value + key)
  }

  return (
    <div className={cn('grid grid-cols-3 gap-2', className)}>
      {KEYS.map((k) => (
        <button
          key={k}
          type="button"
          tabIndex={-1}
          onClick={() => press(k)}
          aria-label={k === 'back' ? 'Backspace' : k}
          className="grid h-12 place-items-center rounded-md bg-fill text-lg font-semibold tabular-nums text-ink transition-colors hover:bg-fill-hover active:bg-selected"
        >
          {k === 'back' ? <Delete className="size-5" /> : k}
        </button>
      ))}
    </div>
  )
}
